import { ChevronDown } from 'lucide-react'
import type { ReactNode, SelectHTMLAttributes } from 'react'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string
}

/** Родной select: на телефоне и в Telegram открывает системный список. */
export function Select({ label, className = '', children, ...rest }: SelectProps) {
  return (
    <label className={`relative inline-flex min-w-0 shrink-0 ${className}`}>
      <span className="sr-only">{label}</span>
      <select
        {...rest}
        className="h-11 w-full min-w-0 cursor-pointer appearance-none truncate rounded-lg bg-card pr-7 pl-2.5 text-sm text-fg ring-1 ring-line outline-none ring-inset desk:h-8 desk:text-[13px]"
      >
        {children}
      </select>
      <ChevronDown size={14} className="pointer-events-none absolute top-1/2 right-2 -translate-y-1/2 text-muted" />
    </label>
  )
}

interface ChipProps {
  active: boolean
  onClick: () => void
  children: ReactNode
  title?: string
}

export function Chip({ active, onClick, children, title }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-pressed={active}
      className={`inline-flex h-11 shrink-0 items-center gap-1.5 rounded-full px-3.5 text-sm whitespace-nowrap transition-colors desk:h-8 desk:px-3 desk:text-[13px] ${
        active ? 'bg-surface font-semibold text-link ring-1 ring-link/30 ring-inset' : 'bg-card text-fg ring-1 ring-line ring-inset hover:bg-surface'
      }`}
    >
      {children}
    </button>
  )
}
